module.exports = __webpack_public_path__ + "cb401cd22427e01d73eff067c38593a7.png";